import axios from 'axios';
import BASE_URL from '../../../config/config';
import { AuthValidation } from "../Views/AuthValidation";
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../config/axiosInstance';

import { useEffect } from 'react';

const useFormSubmission = () => {
  const navigate = useNavigate();

  // Function to refresh token
  const refreshAuthToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      const response = await axios.post(`${BASE_URL}/Auth/refresh`, { token: refreshToken });
      if (response.data.accessToken) {
        localStorage.setItem('token', response.data.accessToken); // Update the new access token
        return response.data.accessToken;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      navigate('/'); // Redirect to login if refresh fails
    }
  };

  const resetAuthToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      const response = await axios.post(`${BASE_URL}/Auth/ResetPassword`, { token: refreshToken });
      if (response.data.accessToken) {
        localStorage.setItem('token', response.data.accessToken); // Update the new access token
        return response.data.accessToken;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      navigate('/'); // Redirect to login if refresh fails
    }
  };

  // Axios interceptor to handle token expiration and refresh
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response, // If response is successful, return it
      async (error) => {
        const originalRequest = error.config;

        // If error is 401 (Unauthorized) and not for the refresh endpoint, try refreshing the token
        if (error.response.status === 401 && originalRequest.url !== `${BASE_URL}/Auth/refresh`) {
          const newToken = await refreshAuthToken(); // Try refreshing token
          if (newToken) {
            // If token is successfully refreshed, retry the original request with the new token
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return axios(originalRequest);
          }
        }

        return Promise.reject(error);
      }
    );

    // Cleanup interceptor when component unmounts
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  const handleSubmit = async (event, formData, setFormData, setErrors, setErrorMessage) => {
    if (event) event.preventDefault();

    const redirectCallback = () => {
      navigate('/'); // Redirect to the login page
    };

    const formErrors = AuthValidation(formData);
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      try {
        const response = await axios.post(`${BASE_URL}/Auth/login`, formData);

        return response;


      } catch (error) {
        console.error('Error posting data:', error);
        setErrorMessage("Error posting data: " + error.message);
      }
    } else {
      setErrorMessage("Form validation errors. Please check your input.");
    }
  };

  return handleSubmit;
};
export const logout = async () => {
  const token = localStorage.getItem('token');

  try {
    if (token) {
      await axiosInstance.post('/Auth/logout', {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  } catch (error) {
    console.error('Logout failed:', error);
  } finally {
    // ✅ Clear both axiosInstance and default axios headers
    delete axiosInstance.defaults.headers.common['Authorization'];
    delete axios.defaults.headers.common['Authorization'];
    
    localStorage.clear();
  }
};
export default useFormSubmission;
